import React, { ReactNode } from 'react';
import { styles } from './PerksContainer.css';

export interface PerksContainerProps {
  children?: ReactNode;
  padding?: 'base' | 'small' | 'medium' | 'large' | 'extraLarge' | 'none';
}
export const PerksContainer = ({ children, padding = 'none' }: PerksContainerProps) => {
  return <div className={styles.container({ padding })}>{children}</div>;
};
